import { render, staticRenderFns } from "./PcFields.vue?vue&type=template&id=475186ca&scoped=true&"
import script from "./PcFields.vue?vue&type=script&lang=js&"
export * from "./PcFields.vue?vue&type=script&lang=js&"
import style0 from "./PcFields.vue?vue&type=style&index=0&id=475186ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475186ca",
  null
  
)

export default component.exports